import { apiClient } from './api';

export interface UnopenedChest {
  id: string;
  buyer: string;
  chestId: number;
  chestName: string;
  price: string;
  chestIndex: number;
  purchaseTime: number;
  txHash: string;
  blockNumber: number;
  isOpened: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface OpenChestResponse {
  buyer: string;
  chestId: number;
  chestName: string;
  price: string;
  chestIndex: number;
  purchaseTime: number;
  txHash: string;
  blockNumber: number;
  isOpened: boolean;
  createdAt: string;
  updatedAt: string;
  rewards: number;
  updated_at: string;
  id: string;
}

export interface VerifyTransactionResponse {
  buyer: string;
  chestId: number;
  chestName: string;
  price: string;
  chestIndex: number;
  purchaseTime: number;
  txHash: string;
  blockNumber: number;
  isOpened: boolean;
  createdAt: string;
  updatedAt: string;
  rewards: number;
  updated_at: string;
  id: string;
}

export const chestService = {
  async getUnopenedChests(): Promise<UnopenedChest[]> {
    const { data } = await apiClient.get<UnopenedChest[]>(
      '/api/v1/chest/unopened'
    );
    return data;
  },

  async openChest(chestId: string): Promise<OpenChestResponse> {
    const { data } = await apiClient.put<OpenChestResponse>(
      `/api/v1/chest/${chestId}/open`
    );
    return data;
  },

  async verifyTransaction(txHash: string): Promise<VerifyTransactionResponse> {
    const { data } = await apiClient.get<VerifyTransactionResponse>(
      `/api/v1/chest/tx/${txHash}`
    );
    return data;
  },
};
